<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "additional_form_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<sp-form-additional-settings
    [isHasSuccessPageOption]="isHasSuccessPageOption"
    [formAdditionalSettings]="itemForm"
    [pages]="websitePages$ | async"
    [siteDomains]="websiteDomains$ | async"
    [baseHref]="baseHref"
    [deviceMode]="selectedDeviceMode$ | async"
    [promoCodes]="promoCodes()"
    [isShopCart]="true"
></sp-form-additional-settings>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
